import {Injectable} from '@angular/core';
import {environment} from '@environments/environment';

/**
 * Service giai quyet URL asset tinh qua CDN Worker hoac fallback ve server goc.
 *
 * Flow:
 * Transloco -> Cloudflare Worker download -> static CDN/assets/language/{lang}.json
 * |
 * +-- loi worker/CDN -> fallback ve assets goc tren server app
 *
 * Service CHI nhan assetPath da duoc feature build san (vi du: /assets/language/vi-VN.json?v=2).
 * Khong hard-code thu muc cu the cua tung feature.
 */
@Injectable({
  providedIn: 'root',
})
export class CdnAssetResolverService {

  /**
   * Kiem tra xem CDN static co duoc cau hinh day du de su dung khong.
   * Can ca isActiveDomainStatic va url.static deu co gia tri.
   */
  isCdnEnabled(): boolean {
    const cf = environment.cloudFlareService;
    return !!(cf?.isActiveDomainStatic && cf?.url?.static);
  }

  /**
   * Build URL truc tiep toi static CDN (khong qua Worker).
   *
   * @param assetPath - Duong dan asset tuong doi, vi du: /assets/i18n/vi-VN.json?v=2
   * @returns URL day du tren CDN, vi du: https://vpage2.static.nvncdn.com/assets/i18n/vi-VN.json?v=2
   */
  getCdnStaticUrl(assetPath: string): string {
    const cf = environment.cloudFlareService;
    return this.joinUrl(cf.url.static, assetPath);
  }

  /**
   * Build URL tai asset qua Cloudflare Worker download (proxy CDN tinh).
   * Worker nhan URL CDN day du qua query `url`, vi du:
   * https://file.workers.nvndev.net/download/?url=https%3A%2F%2Fvpage2.static.nvncdn.com%2Fassets%2Faddress%2Flocation_v1.json%3Fv%3D2
   *
   * @param assetPath - Duong dan asset tuong doi, vi du: /assets/address/location_v1.json?v=2
   * @returns URL Worker download asset tren CDN tinh
   */
  getCdnWorkerUrl(assetPath: string): string {
    const cf = environment.cloudFlareService;
    const cdnUrl = this.joinUrl(cf.url.static, assetPath);
    return `${cf.url.workerDownload}/?url=${encodeURIComponent(cdnUrl)}`;
  }

  /**
   * Build URL fallback ve server goc.
   *
   * @param assetPath - Duong dan asset tuong doi, vi du: /assets/language/vi-VN.json
   * @returns URL day du, vi du: https://vpage.nhanh.vn/assets/language/vi-VN.json
   */
  getAssetFallbackUrl(assetPath: string): string {
    return this.joinUrl(environment.baseUrl, assetPath);
  }

  private joinUrl(baseUrl: string, path: string): string {
    // Nếu path đã là absolute URL → trả về nguyên bản
    if (path?.startsWith('http://') || path?.startsWith('https://')) {
      return path;
    }

    const cleanBase = baseUrl?.endsWith('/') ? baseUrl.slice(0, -1) : (baseUrl ?? '');
    const cleanPath = path.startsWith('/') ? path : `/${path}`;
    return `${cleanBase}${cleanPath}`;
  }
}

